import Image from 'next/image';
import * as React from 'react';
import globeImage from '../../../../public/globe.png';

const GlobePlaceholder = () => {
  return (
    <Image
      className="absolute top-0 blur-sm"
      src={globeImage}
      alt="earth globe"
      width={400}
      height={400}
      quality={25}
    />
  );
};

export default GlobePlaceholder;
